import IPickListViewOptions from "../../models/IPickListViewOptions";
import IViewOptions from "../../models/IViewOptions";
import ControlTypeEnum from "../../models/ControlTypeEnum";
import { useMemo } from "react";

export const usePickListViewOptionsUI = (view: IPickListViewOptions) => {
    const viewOptions: IViewOptions[] = useMemo(() => {
        return [
            {
                title: "show_sku",
                prop: "showSku",
                type: ControlTypeEnum.checkbox,
                value: view.showSku,
            },
            {
                title: "show_item_name",
                prop: "showItemName",
                type: ControlTypeEnum.checkbox,
                value: view.showItemName,
            },
            {
                title: "show_description",
                prop: "showDescription",
                type: ControlTypeEnum.checkbox,
                value: view.showDescription,
            },
            {
                title: "show_control",
                prop: "showControl",
                type: ControlTypeEnum.checkbox,
                value: view.showControl,
            },
            {
                title: "show_item_location",
                prop: "showItemLocation",
                type: ControlTypeEnum.checkbox,
                value: view.showItemLocation,
            },
            {
                title: "group_by_root_category",
                prop: "groupByRootCategory",
                type: ControlTypeEnum.checkbox,
                value: view.groupByRootCategory,
            },
            {
                title: "customer_matrix_layout",
                prop: "customerMatrixLayout",
                type: ControlTypeEnum.checkbox,
                value: view.customerMatrixLayout,
            },
        ];
    }, [view]);

    return viewOptions;
};
